import { render, staticRenderFns } from "./MyButtonEnableDisable2.vue?vue&type=template&id=1027bb8c&scoped=true&"
import script from "./MyButtonEnableDisable2.vue?vue&type=script&lang=js&"
export * from "./MyButtonEnableDisable2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1027bb8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1027bb8c')) {
      api.createRecord('1027bb8c', component.options)
    } else {
      api.reload('1027bb8c', component.options)
    }
    module.hot.accept("./MyButtonEnableDisable2.vue?vue&type=template&id=1027bb8c&scoped=true&", function () {
      api.rerender('1027bb8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/commonComponent/MyButtonEnableDisable2.vue"
export default component.exports